import { Center, Loader } from "@mantine/core";
import PreviewHeader from "components/header/PreviewHeader";
import AdminCreditNotePreview from "pages/admin/dataEntry/AdminCreditNotePreview";
import { useSearchParams } from "react-router-dom";

const PrintCrNote: React.FC = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  if (!id)
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  return (
    <div className="inner-container">
      <PreviewHeader />

      <AdminCreditNotePreview id={Number(id)} />
    </div>
  );
};

export default PrintCrNote;
